import { browser } from "$app/environment";
import constants from "@/constants";
import { AUTH_KEY } from "@/lib/common/constants";
import { getAuthCookieExpireDate } from "@/lib/common/utils";
import Cookies from "js-cookie";
import { writable } from "svelte/store";
import { v4 as uuidv4 } from "uuid";
import { loadLSStateKey, setLSStateKey } from "./localStorage";
const { DEMO_CREDENTIAL, MOJ_USER_NAME, STAGING_DEMO_CREDENTIAL } = constants;
const dataKey = "profile";

const initialState = {
  isTempAuth: false,
  isAuth: false,
  authProvider: null,
  deviceId: Cookies.get("deviceId") || uuidv4(),
  userId:
    process.env.ACTIVE_ENV === "STAGING" ||
    process.env.ACTIVE_ENV === "DEVELOPMENT"
      ? STAGING_DEMO_CREDENTIAL["x-sharechat-userid"]
      : DEMO_CREDENTIAL["x-sharechat-userid"],
  passCode:
    process.env.ACTIVE_ENV === "STAGING" ||
    process.env.ACTIVE_ENV === "DEVELOPMENT"
      ? STAGING_DEMO_CREDENTIAL["x-sharechat-secret"]
      : DEMO_CREDENTIAL["x-sharechat-secret"],
  accessToken: null,
  refreshToken: null,
  userName: MOJ_USER_NAME,
  isOtpVerified: false,
  tenant: null,
  liveStreamId: null,
  referrer: "web",
  showRechargeCta: false,
  uuid: null,
};
const { subscribe, update, set } = writable(initialState);

/**
 *
 * @returns {Object}
 */
const initStore = () => {
  const savedData = loadLSStateKey("state", dataKey);
  const loginCookie = Cookies.get(AUTH_KEY);
  const authData = loginCookie ? JSON.parse(loginCookie) : null;

  let profileData = null;

  if (
    authData &&
    typeof authData === "object" &&
    (authData?.isTempAuth || authData?.isAuth)
  ) {
    profileData = { ...savedData, ...authData };
  }

  if (profileData) {
    set(profileData);
  } else {
    set(initialState);
  }

  subscribe((current) => {
    const {
      isTempAuth,
      isAuth,
      accessToken,
      refreshToken,
      deviceId,
      userId,
      passCode,
      authProvider,
      isOtpVerified,
      tenant,
    } = current;
    setLSStateKey("state", dataKey, current);
    Cookies.set(
      AUTH_KEY,
      JSON.stringify({
        isTempAuth,
        isAuth,
        accessToken,
        refreshToken,
        deviceId,
        userId,
        passCode,
        authProvider,
        isOtpVerified,
        tenant,
      }),
      {
        expires: getAuthCookieExpireDate(),
        ...(browser && window.Cypress
          ? { secure: true, sameSite: "none" }
          : {}),
      }
    );
  });

  return profileData;
};

/**
 *
 * @param {Object} obj
 * @returns
 */
const updateState = (obj) => {
  update((oldState) => ({ ...oldState, ...obj }));
};

const clearState = () => {
  update(() => ({ ...initialState }));
};

if (browser) {
  initStore();
}

export default {
  subscribe,
  updateState,
  clearState,
  initStore,
};
